import { render, staticRenderFns } from "./command-center.vue?vue&type=template&id=3336cc00&scoped=true"
import script from "./command-center.vue?vue&type=script&lang=js"
export * from "./command-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3336cc00",
  null
  
)

export default component.exports